import createBrowserHistory from 'history/createBrowserHistory';
import ga from "analytics";

const history = createBrowserHistory();

history.listen((location, action) => {
    if (action === 'PUSH') {
        ga.trackPage(location);
    }
});

export default history;


// WEBPACK FOOTER //
// ./web/js/browser-history.js